export const themes = [
  'coral',
  'coralLight',
  'dietbet',
  'facebook',
  'landing',
  'runbet',
  'runkeeper',
  'stepbet',
  'sweatbet',
  'waybetter',
  'waybetterLight',
];

export const customThemes = (custom) => themes.concat(custom);
